export default __webpack_public_path__ + "static/media/beer-emoji.b6ed873d.png";